import { render } from "./Pagination.vue?vue&type=template&id=46c75753"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/admin/ui/Pages/Dashboard/Pagination.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "46c75753"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('46c75753', __exports__)) {
    api.reload('46c75753', __exports__)
  }
  
  module.hot.accept("./Pagination.vue?vue&type=template&id=46c75753", () => {
    api.rerender('46c75753', render)
  })

}


export default __exports__